import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export class TransferMethodForm extends UntypedFormGroup {
  constructor() {
    super({
      methodCode: new UntypedFormControl()
    });
  }

  get methodCode(): UntypedFormControl {
    return this.get('methodCode') as UntypedFormControl;
  }
}
